import { OptionModel } from "model/Option.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = OptionModel;

export const useDefaultObservableOptionModel = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectOptionModel extends BehaviorSubject<CurrentType> {}
